import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import WachtwoordVergeten from "@/pages/WachtwoordVergeten";
import WachtwoordHerstellen from "@/pages/WachtwoordHerstellen";
import Dashboard from "@/pages/Dashboard";
import Organisaties from "@/pages/Organisaties";
import OrganisatieDetail from "@/pages/OrganisatieDetail";
import Contactpersonen from "@/pages/Contactpersonen";
import Activiteiten from "@/pages/Activiteiten";
import Producten from "@/pages/Producten";
import ProductDetail from "@/pages/ProductDetail";
import Import from "@/pages/Import";
import Verkoopkansen from "@/pages/Verkoopkansen";
import VerkoopkansDetail from "@/pages/VerkoopkansDetail";
import Belactiviteit from "@/pages/Belactiviteit";
import Verkoopfacturen from "@/pages/Verkoopfacturen";
import VerkoopfactuurDetail from "@/pages/VerkoopfactuurDetail";
import Campagnes from "@/pages/Campagnes";
import CampagnePlanner from "@/pages/CampagnePlanner";
import CampagneAI from "@/pages/CampagneAI";
import CampagneDetail from "@/pages/CampagneDetail";
import CampagneBouwer from "@/pages/CampagneBouwer";
import Segmenten from "@/pages/Segmenten";
import Belmodus from "@/pages/Belmodus";
import Belkansen from "@/pages/Belkansen";
import InstellingenCampagnes from "@/pages/InstellingenCampagnes";
import EmailOntwerpen from "@/pages/EmailOntwerpen";
import InstellingenMenu from "@/pages/InstellingenMenu";
import InstellingenBedrijf from "@/pages/InstellingenBedrijf";
import InstellingenAccount from "@/pages/InstellingenAccount";
import InstellingenGebruikers from "@/pages/InstellingenGebruikers";
import InstellingenGearchiveerd from "@/pages/InstellingenGearchiveerd";
import InstellingenEmail from "@/pages/InstellingenEmail";
import InstellingenVerzending from "@/pages/InstellingenVerzending";
import InstellingenKenmerken from "@/pages/InstellingenKenmerken";
import InstellingenVoorraad from "@/pages/InstellingenVoorraad";
import InstellingenPresentaties from "@/pages/InstellingenPresentaties";
import InstellingenOnderhoud from "@/pages/InstellingenOnderhoud";
import InstellingenWebshopCategorieen from "@/pages/InstellingenWebshopCategorieen";
import InstellingenMoneybird from "@/pages/InstellingenMoneybird";
import InstellingenClaude from "@/pages/InstellingenClaude";
import InstellingenChannelDock from "@/pages/InstellingenChannelDock";
import InstellingenApiKoppelingen from "@/pages/InstellingenApiKoppelingen";
import VoorraadAudits from "@/pages/VoorraadAudits";
import Strategie from "@/pages/Strategie";
import VoorraadAuditDetail from "@/pages/VoorraadAuditDetail";
import Leveranciers from "@/pages/Leveranciers";
import LeverancierDetail from "@/pages/LeverancierDetail";
import Inkooporders from "@/pages/Inkooporders";
import Bevestigingen from "@/pages/Bevestigingen";
import InkoopOrderDetail from "@/pages/InkoopOrderDetail";
import Pakbonnen from "@/pages/Pakbonnen";
import Samples from "@/pages/Samples";
import Bol from "@/pages/Bol";
import Templates from "@/pages/Templates";
import TemplateEditor from "@/pages/TemplateEditor";
import InkomendeOrders from "@/pages/InkomendeOrders";
import WebshopAanvragen from "@/pages/WebshopAanvragen";
import ShopAdresWijzigingen from "@/pages/ShopAdresWijzigingen";
import Inbox from "@/pages/Inbox";
import PresentatieVoorbeeld from "@/pages/PresentatieVoorbeeld";
import WebshopUitnodigingen from "@/pages/WebshopUitnodigingen";
import WebshopActiveren from "@/pages/WebshopActiveren";

function Protected({ children }) {
  const { token, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Laden…</div>;
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/wachtwoord-vergeten" element={<WachtwoordVergeten />} />
          <Route path="/wachtwoord-herstellen" element={<WachtwoordHerstellen />} />
          <Route path="/webshop-activeren/:token" element={<WebshopActiveren />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/organisaties" element={<Organisaties />} />
            <Route path="/organisaties/:id" element={<OrganisatieDetail />} />
            <Route path="/contactpersonen" element={<Contactpersonen />} />
            <Route path="/activiteiten" element={<Activiteiten />} />
            <Route path="/producten" element={<Producten />} />
            <Route path="/producten/:id" element={<ProductDetail />} />
            <Route path="/verkoopkansen" element={<Verkoopkansen />} />
            <Route path="/verkoopkansen/:id" element={<VerkoopkansDetail />} />
            <Route path="/inkomende-orders" element={<InkomendeOrders />} />
            <Route path="/belactiviteit" element={<Belactiviteit />} />
            <Route path="/verkoopfacturen" element={<Verkoopfacturen />} />
            <Route path="/verkoopfacturen/:id" element={<VerkoopfactuurDetail />} />
            <Route path="/pakbonnen" element={<Pakbonnen />} />
            <Route path="/samples" element={<Samples />} />
            <Route path="/bol" element={<Bol />} />
            <Route path="/templates" element={<Templates />} />
            <Route path="/instellingen/templates" element={<Templates />} />
            <Route path="/instellingen/email-ontwerpen" element={<EmailOntwerpen />} />
            <Route path="/templates/:id/bewerken" element={<TemplateEditor />} />
            <Route path="/campagnes" element={<Campagnes />} />
            <Route path="/agenda" element={<CampagnePlanner />} />
            <Route path="/agenda/bellen" element={<Belkansen />} />
            <Route path="/campagnes/planner" element={<CampagnePlanner />} />
            <Route path="/campagnes/ai" element={<CampagneAI />} />
            <Route path="/campagnes/webshop-uitnodigingen" element={<WebshopUitnodigingen />} />
            <Route path="/webshop-aanvragen" element={<WebshopAanvragen />} />
            <Route path="/webshop-adres-wijzigingen" element={<ShopAdresWijzigingen />} />
            <Route path="/campagnes/segmenten" element={<Segmenten />} />
            <Route path="/campagnes/:id/bouwen" element={<CampagneBouwer />} />
            <Route path="/campagnes/:id" element={<CampagneDetail />} />
            <Route path="/bellen" element={<Navigate to="/agenda" replace />} />
            <Route path="/bellen/modus" element={<Belmodus />} />
            <Route path="/instellingen/campagnes" element={<InstellingenCampagnes />} />
            <Route path="/instellingen/menu" element={<InstellingenMenu />} />
            <Route path="/instellingen/bedrijf" element={<InstellingenBedrijf />} />
            <Route path="/instellingen/beldoel" element={<InstellingenAccount />} />
            <Route path="/instellingen/account" element={<InstellingenAccount />} />
            <Route path="/instellingen/gebruikers" element={<InstellingenGebruikers />} />
            <Route path="/instellingen/gearchiveerd" element={<InstellingenGearchiveerd />} />
            <Route path="/instellingen/email" element={<InstellingenEmail />} />
            <Route path="/instellingen/verzending" element={<InstellingenVerzending />} />
            <Route path="/instellingen/voorraad" element={<InstellingenVoorraad />} />
            <Route path="/instellingen/kenmerken" element={<InstellingenKenmerken />} />
            <Route path="/instellingen/presentaties" element={<InstellingenPresentaties />} />
            <Route path="/instellingen/onderhoud" element={<InstellingenOnderhoud />} />
            <Route path="/instellingen/webshop-categorieen" element={<InstellingenWebshopCategorieen />} />
            <Route path="/instellingen/moneybird" element={<InstellingenMoneybird />} />
            <Route path="/instellingen/channeldock" element={<InstellingenChannelDock />} />
            <Route path="/instellingen/api-koppelingen" element={<InstellingenApiKoppelingen />} />
            <Route path="/instellingen/claude" element={<InstellingenClaude />} />
            <Route path="/strategie" element={<Strategie />} />
            <Route path="/voorraadaudit" element={<VoorraadAudits />} />
            <Route path="/voorraadaudit/:id" element={<VoorraadAuditDetail />} />
            <Route path="/leveranciers" element={<Leveranciers />} />
            <Route path="/leveranciers/:id" element={<LeverancierDetail />} />
            <Route path="/inkooporders" element={<Inkooporders />} />
            <Route path="/inkoop/bevestigingen" element={<Bevestigingen />} />
            <Route path="/inbox" element={<Inbox />} />
            <Route path="/organisaties/:id/presentatie-voorbeeld" element={<PresentatieVoorbeeld />} />
            <Route path="/inkooporders/:id" element={<InkoopOrderDetail />} />
            <Route path="/import" element={<Import />} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}
